export const CLOSE_RIGHT_PANE = 'CLOSE_RIGHT_PANE';
export const OPEN_RIGHT_PANE = 'OPEN_RIGHT_PANE';
